export class SelectorComponentInterface{
    setItems(){}
    OnItemSelected(){}
    selectItem(){}
    getItem(){}
}